import { SpatialPlayer, SpatialSnapshot } from './protocol';

export interface TimedSpatialSnapshot extends SpatialSnapshot { receivedAt: number }

const lerp = (from: number, to: number, amount: number) => from + (to - from) * amount;
const lerpYaw = (from: number, to: number, amount: number) => {
  const difference = ((to - from + 540) % 360) - 180;
  return from + difference * amount;
};

/** Samples between authoritative snapshots instead of extrapolating beyond the server. */
export function interpolateSnapshots(from: TimedSpatialSnapshot, to: TimedSpatialSnapshot, renderAt: number): SpatialSnapshot {
  const duration = Math.max(1, to.receivedAt - from.receivedAt);
  const amount = Math.max(0, Math.min(1, (renderAt - from.receivedAt) / duration));
  const previous = new Map(from.players.map(player => [player.userId, player]));
  return {
    selfId: to.selfId,
    players: to.players.map((player): SpatialPlayer => {
      const start = previous.get(player.userId);
      if (!start) return player;
      return {
        ...player,
        position: {
          x: lerp(start.position.x, player.position.x, amount),
          y: lerp(start.position.y, player.position.y, amount),
          z: lerp(start.position.z, player.position.z, amount),
        },
        yaw: lerpYaw(start.yaw, player.yaw, amount),
      };
    }),
  };
}

export function sampleSnapshot(history: TimedSpatialSnapshot[], now: number, delay = 120): SpatialSnapshot {
  if (!history.length) return { selfId: '', players: [] };
  const renderAt = now - delay;
  let toIndex = history.findIndex(snapshot => snapshot.receivedAt >= renderAt);
  if (toIndex < 0) return history[history.length - 1];
  if (toIndex === 0) return history[0];
  return interpolateSnapshots(history[toIndex - 1], history[toIndex], renderAt);
}
